<template>
    <div class="ScenarioList">
        <div class="d-flex align-center justify-space-between header-page">
            <div class="page-title">
                {{ $f.tc('botList') }}
                <v-icon color="#96ADD0" size="26" class="icon-refresh" @click="refresh">refresh</v-icon>
            </div>
            <v-layout align-center justify-end>
                <div v-if="isAdmin" class="btn-custom" @click="openScenarioCreator(null)">
                    <img src="/img/add.svg" alt="icon-add" style="transform: scale(1.2); margin-right: 8px">
                    {{ $f.tc('add') + ' ' + $t('bot') }}
                </div>
            </v-layout>
        </div>
        <v-container
            v-show="!isShowLoading"
            fluid class="fci-scrollbar"
            style="padding: 15px 20px !important; height: calc(100vh - 123px); overflow-y: auto"
        >
            <div v-if="!isHasScenarios" class="centerXY" style="flex-direction: column; height: 100%">
                <img src="/img/contact-admin.svg" alt="icon-contact-admin" style="width: 200px">
                <div class="mt-10 no-permissions">{{ $f.tc('notGrantedCampaignsOrBots', {nameArea: $t('bot')}) }}</div>
                <div class="no-permissions">{{ $f.tc('contactAdminCampaignOrBot', {nameArea: $t('bot')}) }}</div>
                <div class="btn-custom mt-20" @click="refresh">
                    <v-icon color="#FFFFFF" size="20" class="mr-6">refresh</v-icon>
                    {{ $f.tc('refresh') }}
                </div>
            </div>
            <div>
                <v-layout align-center justify-end style="margin-bottom: 16px">
                    <div style="width: 250px; position: relative">
                        <v-text-field
                            hide-details outlined
                            :placeholder="$f.tc('enterToSeacrh')"
                            v-model="filter.search"
                            @keypress.enter="refresh"
                            class="input-custom input-search"
                        ></v-text-field>
                        <img src="/img/scenario/search.svg"
                             alt="icon-search"
                             style="position: absolute; top: 8px; right: 8px; width: 16px; cursor: pointer"
                             @click="refresh"
                        >
                    </div>
                </v-layout>
                <SimpleDataTable
                    :headers="headers"
                    :items="items"
                    :pagination.sync="pagination"
                    @row-click="rowClick($event)"
                >
                    <template v-slot:action="props">
                        <v-btn icon small class="mx-0" @click.stop="openScenarioCreator(props.item)"
                               v-if="isAssignable(props.item)">
                            <img src="/img/edit-blue.svg" alt="icon-edit">
                        </v-btn>
                        <v-btn icon small class="mx-0" @click.stop="deleteScenario(props.item)"
                               v-if="isAssignable(props.item)">
                            <img src="/img/delete-blue.svg" alt="icon-delete" style="transform: scale(1.1);">
                        </v-btn>
                        <v-btn icon small class="mx-0" @click.stop="openScenarioPermission(props.item)"
                               v-if="isAssignable(props.item)">
                            <img src="/img/permission.svg" alt="icon-permission">
                        </v-btn>
                    </template>
                </SimpleDataTable>
            </div>
        </v-container>
        <ScenarioCreatorNew ref="ScenarioCreator"></ScenarioCreatorNew>
        <ScenarioPermission ref="ScenarioPermission"></ScenarioPermission>
    </div>
</template>

<script>
import SimpleDataTable from "@/modules/fptai/components/SimpleDataTable";
import ScenarioService from "@/services/scenario.service";
import ScenarioCreatorNew from "@/views/Scenario/ScenarioCreatorNew";
import ScenarioPermission from "@/views/Scenario/ScenarioPermission";
import store from "@/store/store";
import {mapState} from "vuex";
import lodash from 'lodash'

export default {
    name: "ScenarioList",
    components: {SimpleDataTable, ScenarioCreatorNew, ScenarioPermission},
    data() {
        return {
            filter: {
                search: '',
            },
            pagination: {
                page: 1,
                rowsPerPage: 10
            },
            items: [],
            isHasScenarios: false
        }
    },
    computed: {
        ...mapState({
            isShowLoading: state => state.isShowLoading
        }),
        headers() {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'name'
                },
                {
                    text: this.$f.tc('defaultNLP'),
                    value: 'nlp',
                    $value: item => item.nlp ? item.nlp.name : ''
                },
                {
                    text: this.$t('owner'),
                    value: 'ownerEmail',
                    $value: item => item.owner ? item.owner.email : ''
                },
                {
                    text: this.$t('role'),
                    value: 'user_role'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    id: 'action',
                    type: 'custom'
                }
            ])
        },
        isAdmin() {
            let roles = this.$store.state.user.profile.roles
            return roles && roles.includes('admin')
        }
    },
    mounted() {
        // Perform get all to check if the user has assigned any bot => update isHasCampaign,
        // then filter according to the query
        this.validateQueryURL()
        this.search(false).then(() => {
            let query = this.$utils.cloneObject(this.$route.query)
            if (Object.keys(query).length > 0) {
                this.pagination.page = query.page ? query.page : 1
                delete query.page
                this.filter = {...this.filter, ...query}
                this.search()
            } else {
                this.$appService.hideLoading()
            }
        }).catch(this.$appService.hideLoading)
    },
    methods: {
        refresh() {
            this.pagination.page = 1
            return this.search()
        },
        search(isHideLoading = true) {
            this.$appService.showLoading()
            return ScenarioService.CRUD.search({...this.pagination, search: this.filter.search}).then(result => {
                this.items = result.data.data
                this.pagination.totalItems = result.data.count
                if (result.data.data.length > 0) {
                    this.isHasScenarios = true
                }
            }).finally(() => {
                if (isHideLoading) {
                    this.$appService.hideLoading()
                }
            })
        },
        openScenarioCreator(scenario) {
            this.$refs.ScenarioCreator.open(scenario).then(
                result => {
                    if (scenario) {
                        this.search()
                    } else {
                        this.$router.push('/scenarios/' + result.id + '/')
                    }
                }
            )
        },
        deleteScenario(scenario) {
            this.$appService.confirm(this.$t('confirmDelete', {item: scenario.name})).then(
                () => {
                    ScenarioService.CRUD.delete(scenario.id).then(
                        () => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', {
                                action: this.$t('delete'),
                                item: this.$t('scenario'),
                            }))
                            this.refresh()
                        },
                        this.$appService.handleRequestError()
                    )
                }
            )
        },
        openScenarioPermission(item) {
            this.$refs.ScenarioPermission.open(item.id).then(
                () => this.search()
            )
        },
        rowClick(item) {
            this.$router.push(`/scenarios/${item.id}`)
        },
        isAssignable(scenario) {
            let state = store.state
            let isAdmin = state.user.profile.roles?.includes('admin')
            if (isAdmin) {
                return true
            }
            return scenario.user_role === ScenarioService.UserRole.OWNER;
        },
        validateQueryURL () {
            let query = this.$utils.cloneObject(this.$route.query)
            let allow_queries = ['search', 'page']
            let keys = Object.keys(query)
            keys.forEach(key => {
                if (!allow_queries.includes(key)) {
                    delete query[key]
                }
            })
            if (!lodash.isEqual(query, this.$route.query)) {
                this.$router.replace({
                    query: query
                })
            }
        },
    },
    watch: {
        'pagination.page': function (newPage) {
            let crrQuery = this.$utils.cloneObject(this.$route.query)
            if (newPage !== 1) {
                crrQuery.page = newPage
            } else {
                delete crrQuery.page
            }
            this.$router.replace({
                query: crrQuery
            })
            this.search()
        },
        'pagination.rowsPerPage': 'search',
        filter: {
            deep: true,
            handler: function (newFilter) {
                let query = this.$utils.cloneObject(this.$route.query)
                query = {...query, ...newFilter}
                if (!query.search) {
                    delete query.search
                }
                this.$router.replace({
                    query: query
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;
}

.page-title {
    color: #12274F;
    font-size: 22px;
    font-weight: 700;
    flex: 1 !important;
    padding: 10px 0;
}

.no-permissions {
    //width: 290px;
    font-size: 14px;
    color: #545253;
    text-align: center;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            font-size: 14px;
        }
    }
}

.btn-custom {
    margin-left: 6px;
}

::v-deep {
    .input-search {
        .v-input__slot {
            padding-right: 30px;
        }
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}
</style>
